<!--  -->
<template>
    <div class="specialClassify">
        <div class="btn">
            <el-button type="primary" @click="addClassify">添加分类</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="name" label="分类名称"></el-table-column>
            <el-table-column prop="newscount" label="资讯数量" width="400px" class-name="center"></el-table-column>
            <el-table-column prop="date" label="排序" width="300px" class-name="center">
                <template slot-scope="scope">
                    <div class="sort">
                        <img @click="handleSort(scope, 'up')" v-if="scope.$index !== 0" :src="require('@/common/images/cms/up.png')" alt="">
                        <img @click="handleSort(scope, 'down')" :class="{'down': scope.$index !== 0}" v-if="scope.$index !== tableData.length - 1" :src="require('@/common/images/cms/down.png')" alt="">
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="date" label="操作" width="200px" class-name="right">
                <template slot-scope="scope">
                    <div>
                        <span @click="handleEdit(scope)" class="handle">编辑</span>
                        <span class="line">|</span>
                        <span @click="handleDelete(scope)" class="handle">删除</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page ref="page" @getList="getAllTopiccolumninfo" :total="total" />
        <AddClassify @addClassifySuccess="addClassifySuccess" @editClassifySuccess="editClassifySuccess" :currenttop="currenttop" ref="addClassify" />
        <DeleteClassify :currenttop="currenttop" ref="deleteClassify" @deleteSuccess="deleteSuccess" />
    </div>
</template>

<script>
import {getAllTopiccolumninfo, deleteSxytopiccolumninfo, uploadSxytopiccolumnindex} from 'api/imageText'
import {mapActions} from 'vuex'
import page from '@/base/page/page3'
import AddClassify from './addClassify'
import DeleteClassify from './deleteClassify'
export default {
    data() {
        return {
            tableData: [],
            total: 0,
            page: {
                pageSize: 10,
                page: 1
            },
            editIndex: 0,
            deleteIndex: 0
        }
    },
    props: ['currenttop'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getAllTopiccolumninfo(this.page)
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        // 排序
        handleSort(scope, name) {
            this.setLoading(true)
            uploadSxytopiccolumnindex({
                data: {innerid: scope.row.innerid, topiccode: this.currenttop.topiccode, catetype: name === 'up' ? -1 : 1},
                success: res => {
                    this.setLoading(false)
                    const obj1 = this.tableData[scope.$index]
                    const obj2 = this.tableData[scope.$index - 1]
                    const obj3 = this.tableData[scope.$index + 1]
                    const arr = JSON.parse(JSON.stringify(this.tableData))
                    if (name === 'up') {
                        arr[scope.$index] = obj2
                        arr[scope.$index - 1] = obj1
                    } else {
                        arr[scope.$index] = obj3
                        arr[scope.$index + 1] = obj1
                    }
                    this.tableData = JSON.parse(JSON.stringify(arr))
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        getAllTopiccolumninfo(page) {
            this.setLoading(true)
            getAllTopiccolumninfo({
                data: Object.assign({}, page, {topiccode: this.currenttop.topiccode}),
                success: res => {
                    this.tableData = res.data.content
                    this.total = res.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        handleEdit(scope) {
            this.editIndex = scope.$index
            this.$refs.addClassify.open(scope.row.name, scope.row.innerid)
        },
        handleDelete(scope) {
            this.deleteIndex = scope.$index
            this.$refs.deleteClassify.open(scope.row.innerid)
        },
        deleteSuccess() {
            --this.total
            this.tableData.splice(this.deleteIndex, 1)
            if (!this.tableData.length) {
                --this.$refs.page.pagination.page
                this.getAllTopiccolumninfo(this.$refs.page.pagination)
            }
        },
        addClassifySuccess(obj) {
            ++this.total
            if (this.tableData.length === 10) {
                ++this.$refs.page.pagination.page
                this.getAllTopiccolumninfo(this.$refs.page.pagination)
            } else {
                this.tableData.push(obj)
            }
            console.log(obj)
        },
        editClassifySuccess(obj) {
            this.tableData[this.editIndex].name = obj.name
            console.log(obj)
        },
        // 添加分类
        addClassify() {
            this.$refs.addClassify.open()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        page,
        AddClassify,
        DeleteClassify
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .specialClassify {
        .btn {
            margin-bottom: 20px;
            .el-button {
                width: 110px;
                height: 40px;
            }
        }
        .el-table {
            .center {
                .cell {
                    text-align: center;
                }
            }
            .right {
                .cell {
                    text-align: right;
                }
            }
            .handle {
                color: #409EFF;
                cursor: pointer;
                font-size: 12px;
            }
            .line {
                margin: 0 5px;
                color: #409EFF;
                position: relative;
                top: -1px;
            }
            .sort {
                // width: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    width: 15px;
                    height: 15px;
                    cursor: pointer;
                }
                .down {
                    margin-left: 20px;
                }
            }
        }
    }
</style>